import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

function ResponsiveAppBar() {
  return (
    <AppBar  sx={{ boxShadow: 0, backgroundImage: 'none', alignItems:'center'}}>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Box
          component="img"
          sx={{
            flexGrow:1,
            height: 48,
            width: 48,
            maxHeight: { xs: 48, md: 48 },
            maxWidth: { xs: 48, md: 48 },
          }}
          alt="The house from the offer."
          src="https://firebasestorage.googleapis.com/v0/b/fir-820c7.appspot.com/o/logos%2Flogo_guna.png?alt=media&token=c4457f57-978c-405d-b2f0-4ca2650bae26"
        />
      </Toolbar>
    </AppBar>
  );
}
export default ResponsiveAppBar;